/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

/* eslint-disable @typescript-eslint/no-empty-function */
import { BlockSnapshot, BlockType } from "@vienna/common/src/entities/block-snapshot.entity";

import { PlateSocket } from "../plate/PlateSocket/PlateSocket";
import { Block } from "src/classes/block";
import {
  BlockWindow,
  CodeBlock,
  ColorBlock,
  FileBlock,
  ImageBlock,
  LinkBlock,
  PlateWindowBlock,
  TextBlock,
} from "src/classes/block/block-types";

export class BlockFactory {
  private constructor() {}

  public static create(snapshot: BlockSnapshot, plateSocket: PlateSocket | null): Block {
    switch (snapshot.type) {
      case BlockType.Text:
        return new TextBlock(snapshot, plateSocket);
      case BlockType.Image:
        return new ImageBlock(snapshot, plateSocket);
      case BlockType.Link:
        return new LinkBlock(snapshot, plateSocket);
      case BlockType.PlateWindow:
        return new PlateWindowBlock(snapshot, plateSocket);
      case BlockType.Color:
        return new ColorBlock(snapshot, plateSocket);
      case BlockType.File:
        return new FileBlock(snapshot, plateSocket);
      case BlockType.Code:
        return new CodeBlock(snapshot, plateSocket);
      case BlockType.BlockWindow:
        return new BlockWindow(snapshot, plateSocket);
    }
  }
}
